<ada-card
	#MediaDetectionPropertiesCard
	id="MediaDetectionPropertiesCard"
	[collapseEnabled]="true"
	[verticalSpacing]="'Small'"
	width="100%"
>
	<ada-text
		id="MediaDetectionPropertiesCardHeader"
		data-container-selector="ada-card-header"
		content="Media Detection Properties"
	></ada-text>
	<ada-container
		data-container-selector="ada-card-body"
		[colCount]="4"
		verticalSpacing="Medium"
		horizontalSpacing="Medium"
		[padding]="defaultCardPadding"
	>
		<!-- TODO: Replace with appropriate input -->
		<ng-container *ngIf="'FileNamePattern' | displayAuthoringProperty: editorClass:propertyConstructor.namespace">
			<ada-authoring-property-label
				#FileNamePatternLabel
				id="FileNamePatternLabel"
				[content]="'File Name Pattern'"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				[inheriting]="currentPropertyObject?.FileNamePattern | inheritPipe:inheritedPropertyObject?.FileNamePattern"
				[isRequired]="'FileNamePattern' | isRequiredProperty: editorClass: propertyConstructor.namespace"
				[isDisabled]="isDisabled"
				(inheritanceChange)="deleteObjectPropertyValue('FileNamePattern')"
			></ada-authoring-property-label>
			<ada-container
				[colSpan]="3"
				[colCount]="2"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-input
					#FileNamePatternInput
					id="FileNamePatternInput"
					[type]="'text'"
					[debounce]="100"
					[showAsFullWidth]="true"
					[maxCharacterLimit]="255"
					[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_WRAPPED_FIELD_CONFIG"
					[value]="currentPropertyObject?.FileNamePattern"
					[isDisabled]="isDisabled"
					(valueChange)="setObjectPropertyValue('FileNamePattern', $event)"
				></ada-input>
			</ada-container>
		</ng-container>
		<ng-container *ngIf="'KeyFileName' | displayAuthoringProperty: editorClass:propertyConstructor.namespace">
			<ada-authoring-property-label
				#KeyFileNameLabel
				id="KeyFileNameLabel"
				[content]="'Key File Name'"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				[inheriting]="currentPropertyObject?.KeyFileName | inheritPipe:inheritedPropertyObject?.KeyFileName"
				[isRequired]="'KeyFileName' | isRequiredProperty: editorClass: propertyConstructor.namespace"
				[isDisabled]="isDisabled"
				(inheritanceChange)="deleteObjectPropertyValue('KeyFileName')"
			></ada-authoring-property-label>
			<ada-container
				[colSpan]="3"
				[colCount]="2"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-input
					#KeyFileNameInput
					id="KeyFileNameInput"
					[type]="'text'"
					[debounce]="100"
					[showAsFullWidth]="true"
					[maxCharacterLimit]="255"
					[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_WRAPPED_FIELD_CONFIG"
					[placeholder]="'Key File Name'"
					[value]="currentPropertyObject?.KeyFileName"
					[isDisabled]="isDisabled"
					(valueChange)="setObjectPropertyValue('KeyFileName', $event)"
				></ada-input>
			</ada-container>
		</ng-container>
		<!-- TODO: Replace with appropriate input -->
		<ng-container *ngIf="'MediaDetectionSensorExpression' | displayAuthoringProperty: editorClass:propertyConstructor.namespace">
			<ada-authoring-property-label
				#MediaDetectionSensorExpressionLabel
				id="MediaDetectionSensorExpressionLabel"
				[content]="'Media Detection Sensor Expression'"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				[inheriting]="currentPropertyObject?.MediaDetectionSensorExpression | inheritPipe:inheritedPropertyObject?.MediaDetectionSensorExpression"
				[isRequired]="'MediaDetectionSensorExpression' | isRequiredProperty: editorClass: propertyConstructor.namespace"
				[isDisabled]="isDisabled"
				(inheritanceChange)="deleteObjectPropertyValue('MediaDetectionSensorExpression')"
			></ada-authoring-property-label>
			<ada-container
				[colSpan]="3"
				[colCount]="2"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-input
					#MediaDetectionSensorExpressionInput
					id="MediaDetectionSensorExpressionInput"
					[type]="'text'"
					[debounce]="100"
					[showAsFullWidth]="true"
					[maxCharacterLimit]="255"
					[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_WRAPPED_FIELD_CONFIG"
					[placeholder]="'Media Detection Sensor Expression'"
					[value]="currentPropertyObject?.MediaDetectionSensorExpression"
					[isDisabled]="isDisabled"
					(valueChange)="setObjectPropertyValue('MediaDetectionSensorExpression', $event)"
				></ada-input>
			</ada-container>
		</ng-container>
	</ada-container>
</ada-card>
